import { apiClient } from '../api'

export type BillingState =
  | 'TRIALING'
  | 'ACTIVE'
  | 'PAST_DUE'
  | 'CANCELLING'
  | 'CANCELLED'
  | 'EXPIRED'

export interface Entitlements {
  MAX_PRODUCTS: number | null
  MAX_MEMBERS: number | null
  CAN_EXPORT: boolean
  CAN_USE_CUSTOM_SUBREQS: boolean
}

export interface BillingStatus {
  billingState: BillingState
  trialEndsAt: string | null
  daysRemaining: number | null
  currentPeriodEndsAt: string | null
  entitlements: Entitlements
}

export interface CheckoutInfo {
  priceId: string
  email: string
  orgId: string
}

export async function getBillingStatus(orgId: string): Promise<{ data: BillingStatus }> {
  const res = await apiClient.get<{ data: BillingStatus }>(`/orgs/${orgId}/billing/status`)
  return res.data
}

export async function createCheckout(orgId: string): Promise<{ data: CheckoutInfo }> {
  const res = await apiClient.post<{ data: CheckoutInfo }>(`/orgs/${orgId}/billing/checkout`)
  return res.data
}

export async function createPortalSession(orgId: string): Promise<{ data: { portalUrl: string } }> {
  const res = await apiClient.post<{ data: { portalUrl: string } }>(`/orgs/${orgId}/billing/portal`)
  return res.data
}
